<template>
	<vx-card class="author-upload">
		<div v-if="canUploadFiles">
			<UploadAuthorsWork
				:order-status="orderStatus"
				:order-id="orderId"
				:stage="stage"
				@update-model="updateModel"
			/>
		</div>

		<div v-else class="author-upload__instruction py-3 bold">
			<b>
				{{ $t('uploadAuthorFilesInstruction') }}!
			</b>
		</div>
	</vx-card>
</template>

<script>
import UploadAuthorsWork from '@/components/authors/UploadAuthorsWork.vue'

export default {
	name: "AuthorUpload",
	props: {
		orderId: { required: true, type: Number },
		orderStatus: { required: true, type: String },
		stage: { default: () => [] },
		canUploadFiles: {
			required: true,
			type: Boolean,
			default: false
		}
	},
	components: {
		UploadAuthorsWork
	},
	methods: {
		async updateModel(callback) {
			await this.$emit("updateModel", callback);
		},
	}
};
</script>

<style lang="scss">
</style>
